import { authenticatedFetch } from '../../../api/request';

export default async function getSecondarySpecialtiesByPrimaryId(primarySpecialtyId, setErrorMessage) {
    const onError = () => setErrorMessage('No se puede obtener las especialidades secundarias para esta especialidad principal.');
    return await authenticatedFetch(`/specialty/get-secondary/${primarySpecialtyId}`, onError);
}
